import { useContext, useEffect } from "react";
import FormContext from "../../context/FormContext.js";
import Container from "../../components/FormContainer/FormContainer.js";
import Row from "../../components/RowField/RowField.js";
import Section from "../../components/FormSection/FormSection.js";
import Input from "../../components/InputField/InputField.js";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import { createList } from "../../utils/utils.js";
import StaticDataContext from "../../context/StaticDataContext.js";

export default function ResidencyLanguageCitizenship() {
    const { formData, updateFormData } = useContext(FormContext);
    const { injectFormProps } = useInjectFormProps();
    const { staticData } = useContext(StaticDataContext);

    useEffect(() => {
        const status = formData["countryOfBirth"] === "CA" ? "CC" : "NCC";
        updateFormData({ immigrationStatus: status });
    }, [formData['countryOfBirth']])

    return (
        <Container>
            {injectFormProps(
                <>
                    <Section title={"Residency/Language Information"}>
                        <Row>
                            <Input type="select" inputLabel={"Country of Birth"} identifier={"countryOfBirth"} options={createList(staticData, "countries")} />
                            {formData["isHomeEnglishOnly"] === "0"
                                ? <Input type="text" inputLabel={"List all language(s) spoken at home"} identifier={"langSpoken"} />
                                : <Input type="text" inputLabel={"List all language(s) spoken at home"} identifier={"langSpoken"} value={"English"} disabled />
                            }
                        </Row>
                        <Row>
                            {formData['workingWithSWIS'] === "1" &&
                                <Input type="select" inputLabel={"Country of Citizenship"} identifier={"countryOfCitizenship"} options={createList(staticData, "countries", { Code: ["CA"]}, undefined, undefined, true)} />
                            }
                        </Row>
                        <Input type="noyesradio" inputLabel={"Is the student an SK Resident?"} identifier={"isStudentSKResident"}
                            hint={"A Saskatchewan resident is someone who owns, rents or leases a residence in Saskatchewan or resides with an immediate family member who is a Saskatchewan resident"} />
                    </Section>
                    <hr />
                    <Section title={"Immigration Status"}>
                        {
                            formData["isCanCit"] === "1" ?
                                <>
                                    <Input type="select" inputLabel={"Status"} identifier={"immigrationStatus"}
                                        options={createList(staticData, "immStatus", { Code: ["CC", "NCC"] })}
                                        disabled
                                        value={formData['immigrationStatus']}
                                    />
                                    {
                                        formData["countryOfBirth"] !== "CA" &&
                                        <Input type="date" inputLabel={"Date of Entry to Canada"} identifier={"canadaEntryDate"} mandatory={false} />
                                    }
                                </>
                                : <>
                                    <Input type="select" inputLabel={"Status"} identifier={"immigrationStatus"}
                                        options={createList(staticData, "immStatus", { Code: ["CC", "NCC"] }, undefined, undefined, true)}
                                    />
                                    <Input type="date" inputLabel={"Date of Entry to Canada"} identifier={"canadaEntryDate"}
                                        mandatory={formData["countryOfBirth"] !== "CA"} disabled={(formData["countryOfBirth"] === "CA" && formData["isCanCit"] === "1")} />
                                </>
                        }
                    </Section>
                    {formData["isCanCit"] === "1" &&
                        <>
                            <hr />
                            <Section title={"Indigenous Self-Declaration Information"}>
                                <p>The self-declaration information will be used solely to help shape programming and services designed to support the success and achievement of Indigenous students throughout their educational journey.</p>
                                <b>Indigenous people are those who identify themselves to be First Nations (Registered/Treaty/Status Indian, Non-Status Indian), Metis, or Inuit/Inuk.</b>
                                <Input type="noyesradio" inputLabel={"Is the student of Indigenous ancestry?"} identifier={"isIndigenousAncestry"} />
                                {formData["isIndigenousAncestry"] === "1" &&
                                    <>
                                        <Input type="noyesradio" inputLabel={"Does the student reside on reserve?"} identifier={"studentResidesOnReserve"} />
                                        {
                                            formData["studentResidesOnReserve"] === "1" &&
                                            <Input type="text" inputLabel={"Reserve of Residence"} identifier={"reserveResidence"} />
                                        }
                                        <Row>
                                            <Input type="select" inputLabel={"What is the student's Indigenous identity?"} identifier={"indigenousGroup"} options={createList(staticData, "indGroup")} />
                                            <Input type="text" inputLabel={"Indian Registry Number"} identifier={"indigenousRegistryNo"} mandatory={false} />
                                            <Input type="select" inputLabel={"Band Affiliation Name"} identifier={"indigenousBandName"} mandatory={false} options={createList(staticData, "bandAffiliation")} />
                                        </Row>
                                    </>
                                }
                            </Section>
                        </>
                    }
                </>)}
        </Container>
    )
}